import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { CONTENT_TYPE } from "../common";
import { isJsonLikeContentType } from "../helper";
export function defaultErrorResponseHandler(_x) {
  return _defaultErrorResponseHandler.apply(this, arguments);
}
function _defaultErrorResponseHandler() {
  return (_defaultErrorResponseHandler = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(response) {
    var message, error, contentType;
    return _regeneratorRuntime.wrap(function (_context) {
      for (;;) switch (_context.prev = _context.next) {
        case 0:
          if (error = {
            status: response.status,
            statusText: response.statusText || "<none>"
          }, !(contentType = response.headers.get(CONTENT_TYPE))) {
            _context.next = 13;
            break;
          }
          if (!isJsonLikeContentType(contentType)) {
            _context.next = 9;
            break;
          }
          return _context.next = 6, response.json();
        case 6:
          message = _context.sent, _context.next = 13;
          break;
        case 9:
          return _context.next = 11, response.text();
        case 11:
          _context.t0 = _context.sent, message = {
            message: _context.t0
          };
        case 13:
          return _context.abrupt("return", _Promise.reject(_objectSpread(_objectSpread({}, error), message)));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))).apply(this, arguments);
}